import React, { ReactNode, forwardRef, HTMLAttributes } from 'react';
import cx from 'clsx';

import { CARD_TEST_ID } from './const';

import styles from './styles.module.scss';

type CardProps = HTMLAttributes<HTMLElement> & {
  includeBodyPadding?: boolean;
  children?: ReactNode;
};

const Card = forwardRef<HTMLElement, CardProps>((props, ref) => {
  const { className, children, includeBodyPadding = true, ...rest } = props;

  const spreadableProps = {
    'data-testid': CARD_TEST_ID,
    'className': cx(styles.card, {
      [styles.cardWithPadding]: includeBodyPadding
    }, className),
    ...rest,
  };

  return (
    <section {...spreadableProps} ref={ref}>
      {children}
    </section>
  );
});

export { Card };
